import { GET_PURCHASE_ORDERS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_PURCHASE_ORDERS:
            return action.payload;

        default:
            return state;
    }
}